import { EmptyState } from '../components/ui';

export function NotFound() {
  return (
    <main className="workspace-main">
      <EmptyState
        index="404 / NOT FOUND"
        title="Page not found"
        detail="That route does not exist."
        action={
          <a className="button button-default" href="/">
            Back to overview
          </a>
        }
      />
    </main>
  );
}
